/* eslint-disable */
const $ = jQuery;

$(document).ready(function () {


  // close the 3rd level of categories in
  let subTrees = $('.term-reference-tree > ul > li > ul > li > .term-reference-tree-button');
  subTrees.each(function () {
    $(this).trigger('click');
  })

  if (window.matchMedia("(max-width: 769px)").matches) {
    var clonedDiv = $('.lg-ads-section').clone();
    clonedDiv.insertAfter('.node .card-header');
  }

  var searchParams = new URLSearchParams(window.location.search);

  // Check if the 'destination' parameter is present and matches the specified value
  if (searchParams.get('destination') === '/fr/node/add/card') {
    // Show the div with id="alert"
    $('#login-alert').show();
  }

  // let messages = $("div").find(`[data-drupal-messages]`)
  let messages = document.querySelectorAll(`[data-drupal-messages]`);
  // loop over each message and add the alert class
  messages.forEach(message => {
    message.classList.add('alert', 'alert-success', 'alert-dismissible', 'fade', 'show');
  })

  // show comment box if present in anchor
  let hash = window.location.hash;

  // Check if the hash starts with '#comment-step'
  if (hash.startsWith('#comment-step')) {
    // Trigger a click event on the element with the same ID as the hash
    $(hash + ' a:nth-child(3)').click();
  }

  $(document).on('mouseover', '.card-comment-link-wp .review-star, .upstate .review-star',function (event) {
    $(this).addClass('active');
    for (var x = 0; x < 6; x++) {
      if (x < $(this).index()) {
        $(this).siblings().eq(x).addClass('active');
      } else {
        $(this).siblings().eq(x).removeClass('active');
      }
    }
  });

  $(document).on('click', '.card-comment-link-wp .review-star, .upstate .review-star',function (event) {

    if($(this).hasClass('not-logged-in')){
      event.preventDefault();
      window.location.href = '/user/login?destination=' + window.location.pathname;
    } else {
      $('#rating-modal').addClass('show');
      let rating = $(this).data('note');
      let stars = $('#rating-modal .review-star');
      $('#send-rating').data('note', rating);
      for (var x = 0; x < 6; x++) {
        if (x < rating) {
          $(stars[x]).addClass('active')
        } else {
          $(stars[x]).removeClass('active')
        }
      }
    }
  });

  $(document).on('click', '#rating-modal .close, #modal-overlay',function (event) {
    $('#rating-modal').removeClass('show');
  });

  $(document).on('click', '#send-rating',function (event) {

    let node = $(this).data('guide-id');
    let rating = $(this).data('note');
    let button = $(this);
    button.prop('disabled', true).css({'opacity':'0.5','cursor':'not-allowed'});
    $.ajax({
      url: '/star/rating?nid='+node+'&rating=' + rating,
      type: 'GET',
      success: function (result) {
        $('#modal-success').show();
      }
    });

  })


  // GA4 Event tracking
  window.dataLayer = window.dataLayer || [];

  $(document).on('submit','.user-login-form', function (event) {
    window.dataLayer.push({
      'event' : 'login',
      'label' : 'Website login'
    });
    console.log('user login event')
  })

  $(document).on('submit', '.user-register-form',function (event) {
    window.dataLayer.push({
      'event' : 'new_account',
      'label' : 'Website new account'
    });
    console.log('user-register event')
  })

  $(document).on('submit', '.node-card-form',function (event) {

    var $inputs = $('.node-card-form :input');

    // Send data for each step based on fields on each step.
    // If we are updating the form display widget then we will need to update this.
    var values = [];
    $inputs.each(function() {
      if (this.name == 'title[0][value]') {
        window.dataLayer.push({
          'event' : 'guide_form_submit',
          'label' : 'Titre et présentation Step (Guide Submit)'
        });
        console.log("Titre et présentation Step (Guide Submit)");
      }
      if (this.name.includes('field_categories')) {
        window.dataLayer.push({
          'event' : 'guide_form_submit',
          'label' : 'Catégorie Step (Guide Submit)'
        });
        console.log("Catégorie Step (Guide Submit)");
      }
      if (this.name.includes('field_difficulties')) {
        window.dataLayer.push({
          'event' : 'guide_form_submit',
          'label' : 'Difficulté, durée et coût Step (Guide Submit)'
        });
        console.log("Difficulté, durée et coût Step (Guide Submit)");
      }
      if (this.name.includes('field_materials')) {
        window.dataLayer.push({
          'event' : 'guide_form_submit',
          'label' : 'Matériaux et outils Step (Guide Submit)'
        });
        console.log("Matériaux et outils Step (Guide Submit)");
      }
      if (this.name.includes('field_step')) {
        window.dataLayer.push({
          'event' : 'guide_form_submit',
          'label' : 'Étape(s) Step (Guide Submit)'
        });
        console.log("Étape(s) Step (Guide Submit)");
      }
      if (this.name.includes('field_video')) {
        window.dataLayer.push({
          'event' : 'guide_form_submit',
          'label' : 'Vidéo, Audio et .pdf Step (Guide Submit)'
        });
        console.log("Vidéo, Audio et .pdf Step (Guide Submit)");
      }
      if (this.name.includes('field_tips')) {
        window.dataLayer.push({
          'event' : 'guide_form_submit',
          'label' : 'Conseil, autres guides et Tag Step (Guide Submit)'
        });
        console.log("Conseil, autres guides et Tag Step (Guide Submit)");
      }
      if (this.name.includes('field_original_source')) {
        window.dataLayer.push({
          'event' : 'guide_form_submit',
          'label' : 'Références Step (Guide Submit)'
        });
        console.log("Références Step (Guide Submit)");
      }
      if (this.name.includes('field_merchant_websites_keywords')) {
        window.dataLayer.push({
          'event' : 'guide_form_submit',
          'label' : 'Publicités Step (Guide Submit)'
        });
        console.log("Publicités Step (Guide Submit)");
      }
      if (this.name.includes('field_private_note')) {
        window.dataLayer.push({
          'event' : 'guide_form_submit',
          'label' : 'Note privée Step (Guide Submit)'
        });
        console.log("Note privée Step (Guide Submit)");
      }
    });
  })

  // Commented this code as it is moved to the module file.
  // $(document).on('submit', '.comment-form',function (event) {
  //   window.dataLayer.push({
  //     'event' : 'new_comment',
  //     'label' : 'New Comment Submit'
  //   });
  //   console.log('event')
  // })
})
